/**
 * Email verification landing route.
 *
 * BetterAuth's GET /api/auth/verify-email processes the token from the
 * email link, marks `better_auth_user.email_verified = true`, optionally
 * issues a session cookie (`autoSignInAfterVerification: true`), then
 * 302s here. The query string carries `?error=...` on failure or `?token`
 * (consumed and stripped server-side) on success.
 *
 * Phase Email-Verification-1 (2026-05-20).
 */

import { createFileRoute, redirect } from '@tanstack/react-router'

const SUPPORTED_LOCALES = ['es', 'gl', 'en', 'de', 'fr', 'it', 'nl', 'pt']

export const Route = createFileRoute('/$locale/verify-email')({
  beforeLoad: ({ params }) => {
    if (!SUPPORTED_LOCALES.includes(params.locale)) {
      throw redirect({ to: '/$locale/verify-email', params: { locale: 'en' }, search: {} })
    }
  },
  validateSearch: (s: Record<string, unknown>) => ({
    ...(typeof s.error === 'string' ? { error: s.error } : {}),
    ...(typeof s.email === 'string' ? { email: s.email } : {}),
  }),
})
